var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0.05 0.04 6 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03868608,3.06726912 C6.03868608,4.70870142 4.70822215,6.03868608 3.06726912,6.03868608 C1.42631609,6.03868608 0.09585216,4.70870142 0.09585216,3.06726912 C0.09585216,1.42679535 1.42631609,0.09585216 3.06726912,0.09585216 C4.70822215,0.09585216 6.03868608,1.42679535 6.03868608,3.06726912 Z M3.06726912,3.66634512 C2.7628786,3.66634512 2.5161192,3.91310452 2.5161192,4.21749504 C2.5161192,4.52188556 2.7628786,4.76864496 3.06726912,4.76864496 C3.37165964,4.76864496 3.61841904,4.52188556 3.61841904,4.21749504 C3.61841904,3.91310452 3.37165964,3.66634512 3.06726912,3.66634512 Z M2.5440002,1.68524871 L2.63287911,3.31473543 C2.6370367,3.39098583 2.70008346,3.45067776 2.77644169,3.45067776 L3.35809655,3.45067776 C3.43445478,3.45067776 3.49750154,3.39098583 3.50165913,3.31473543 L3.59053804,1.68524871 C3.59503111,1.60288775 3.52945625,1.53363456 3.44697547,1.53363456 L2.68755079,1.53363456 C2.60507,1.53363456 2.53950713,1.60288775 2.5440002,1.68524871 L2.5440002,1.68524871 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.6bcc36e4b62fe98d99b72985af056bec.svg";
export { ForwardRef as ReactComponent };